import React from 'react';

import { DropdownFavoriteOptionIcon } from 'components/pages/ModeReports/DropdownFavoriteOptionIcon/DropdownFavoriteOptionIcon';

const StudyOptionTemplateMultiSelect = ({ option = {}, setOptionsAsFavorite, favoriteOptions }) => {
  const { pcn, name } = option;

  return (
    <div className="dashboard-study-pcn-option-template-multi-select">
      <div>
        {pcn && <div className="dashboard-study-pcn-control-study-pcn-label">{pcn}</div>}
        <div>{name}</div>
      </div>
      <DropdownFavoriteOptionIcon
        setOptionsAsFavorite={setOptionsAsFavorite}
        option={option}
        favoriteOptions={favoriteOptions}
      />
    </div>
  );
};

export { StudyOptionTemplateMultiSelect };
